import axios from "axios";

/** API base — same origin in production (main + tracking domains); env override for local dev. */
function resolveApiBase() {
  const envUrl = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
  if (typeof window === "undefined") {
    return envUrl ? `${envUrl}/api` : "/api";
  }
  const isLocalDev =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  if (isLocalDev && envUrl) {
    return `${envUrl}/api`;
  }
  // Production: nginx proxies /api on whichever host served the app (Cloudflare, tracking CNAME, etc.)
  return `${window.location.origin}/api`;
}

export const API = resolveApiBase();

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (
      err?.response?.status === 401 &&
      !err.config?.skipAuthRedirect &&
      !window.location.pathname.startsWith("/login") &&
      !window.location.pathname.startsWith("/register")
    ) {
      localStorage.removeItem("mc_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

/** FastAPI errors: detail may be a string or validation array — safe for toast/UI. */
export function formatApiDetail(err, fallback = "Request failed") {
  const d = err?.response?.data?.detail;
  if (Array.isArray(d)) {
    return d
      .map((x) => (x && typeof x === "object" && x.msg ? x.msg : String(x)))
      .filter(Boolean)
      .join("; ") || fallback;
  }
  if (typeof d === "string" && d.trim()) return d;
  if (d != null && typeof d === "object") {
    try {
      return JSON.stringify(d);
    } catch {
      return fallback;
    }
  }
  if (err?.message) return err.message;
  return fallback;
}

export default api;
